import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Spinner,
  Center,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { getPublicMissionStatus } from "../../api/partnersApi";

const LandingSuccess = () => {
  const { token } = useParams();
  const { t, i18n } = useTranslation("public");
  const [loading, setLoading] = useState(true);
  const [missionTitle, setMissionTitle] = useState("");

  // Public-facing page defaults to French unless the user explicitly chose English
  useEffect(() => {
    const explicit = window.localStorage.getItem("portalLanguage");
    if (!explicit) {
      i18n.changeLanguage("fr");
    }
  }, [i18n]);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const data = await getPublicMissionStatus(token);
        setMissionTitle(data.title || "");
      } catch {
        // Non-critical — just won't show the mission title
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
  }, [token]);

  if (loading) {
    return (
      <Box minH="100vh" bg="gray.50" py={8}>
        <Container maxW="container.md">
          <Center h="60vh">
            <Spinner size="xl" color="blue.500" thickness="4px" />
          </Center>
        </Container>
      </Box>
    );
  }

  return (
    <Box minH="100vh" bg="gray.50" py={8}>
      <Container maxW="container.md">
        <Box bg="white" borderRadius="lg" borderWidth="1px" p={6} shadow="sm">
          <VStack spacing={6} align="center" py={8}>
            <Alert
              status="success"
              variant="subtle"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              borderRadius="lg"
              py={8}
            >
              <AlertIcon boxSize="50px" mr={0} />
              <AlertTitle mt={4} mb={2} fontSize="xl">
                {t("landing.success.title")}
              </AlertTitle>
              <AlertDescription maxWidth="md">
                <VStack spacing={3}>
                  {missionTitle && (
                    <Text fontWeight="semibold" color="gray.700">
                      {missionTitle}
                    </Text>
                  )}
                  <Text color="gray.600">
                    {t("landing.success.message")}
                  </Text>
                  <Text fontSize="sm" color="gray.500" mt={2}>
                    {t("landing.success.closePage")}
                  </Text>
                </VStack>
              </AlertDescription>
            </Alert>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default LandingSuccess;
